import $ from 'jquery';

$(document).ready(function () {

  (function () {
    const $cardSwitcher = $('.card-switcher-container');
    const $cards        = $('.card-switcher-item');

    if (!$cardSwitcher.length || !$cards.length) {
      return;
    }

    /* -----------------------------------------------------------------
     * 1.  Initial state – stack the cards with a small rotation offset
     * ---------------------------------------------------------------*/
    $cards.each(function (i) {
      $(this).css({
        transform: `rotate(${i * 2}deg)`
      });
    });

    /* smooth transition for all cards */
    $cards.css({
      transition: 'transform 0.4s ease-in-out, opacity 0.4s ease-in-out'
    });

    /* -----------------------------------------------------------------
     * 2. Click driven animation
     * ---------------------------------------------------------------*/
    let activeCardIndex = 0;
    const totalCards    = $cards.length;
    const LAST_CARD     = totalCards - 1;

    $cardSwitcher.on('click', function (e) {
      /* Ignore clicks that originate from the “reset card” so we don’t
       * immediately animate the first card after a reset. */
      if ($(e.target).closest('.resetcards').length) {
        return;
      }

      /* Do nothing if all animatable cards have already been moved */
      if (activeCardIndex >= LAST_CARD) {
        return;
      }

      const $card = $cards.eq(activeCardIndex);

      /* final transform values */
      const baseRotation = activeCardIndex * 2;  // initial offset
      const rotation     = baseRotation + 45;    // add 45°
      const translateX   = 800;                  // slide right
      const translateY   = -400;                 // slide up

      $card.css({
        transform: `translateX(${translateX}px) translateY(${translateY}px) rotate(${rotation}deg)`,
        opacity  : 0
      });

      activeCardIndex++;
    });

    /* -----------------------------------------------------------------
     * 3. Restore logic
     * ---------------------------------------------------------------*/
    function resetCards () {
      $cards.each(function (i) {
        $(this).css({
          transform: `rotate(${i * 2}deg)`,
          opacity  : 1
        });
      });
      activeCardIndex = 0;
    }

    $(window).on('scroll', function () {
      const scrollTop        = $(this).scrollTop();
      const restoreThreshold = $cardSwitcher.offset().top + 1000;

      if (scrollTop > restoreThreshold && activeCardIndex > 0) {
        resetCards();
      }
    });

    $('.resetcards').on('click', function (e) {
      /* Prevent the click from bubbling up to the container which would
       * trigger the card-switcher click handler. */
      e.stopPropagation();
      console.log('reset cards');
      resetCards();
    });

  })();



  /* ---------------------------------------------------------------
   * 4.  Utility – min-height calculations
   * -------------------------------------------------------------*/
  function setMinHeight () {
    let maxHeight = 0;
    $('.card-switcher-item').each(function () {
      const itemHeight = $(this).outerHeight();
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });
    $('.card-switcher-container').css('min-height', maxHeight);
    $('.card-switcher-item').css('min-height', maxHeight);
  }

  setTimeout(setMinHeight, 1000);

  /* update height on resize */
  $(window).resize(function () {
    setMinHeight();
  });

});